import type { Contract } from '@st/sdk'
import { match, P } from '@st/pattern'
import type { DocumentTopBarProps } from '../top-bar-types'

export const renderEngagementLetterDocumentTopBar = (
  contract: Contract,
  _props: DocumentTopBarProps
) =>
  match(contract)
    .with({ status: P.union('draft', 'published') }, () => null)
    .with({ status: 'submitted' }, () => (
      <div className="pointer-events-auto flex items-center bg-green-300 px-5 text-base text-green-800">
        This engagement letter has been signed.
      </div>
    ))
    .exhaustive()
